export default __webpack_public_path__ + "static/media/thumbnail.f150346e.png";